<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="success" @click="getPaymentPending"
        ><v-icon>send</v-icon><span>Payment Pending</span></v-btn
      ></template
    >
    <v-card>
      <v-card-title>
        <h2>Mark Order as Dispatched</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="cartId"
            label="CartId"
            prepend-icon="shopping_cart"
            disabled
          ></v-text-field>
          <v-chip
            v-if="!paymentFlag"
            class="ma-2"
            color="red"
            text-color="white"
          >
            Payment is pending
          </v-chip>
          <v-chip
            v-if="paymentFlag"
            class="ma-2"
            color="green"
            text-color="white"
          >
            Payment is done
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            v-if="paymentFlag"
            @click="submitSetPending"
            class="success mx-1"
            :loading="loading"
            >Set Pending Payment</v-btn
          >
          <v-btn
            v-if="!paymentFlag"
            @click="submitResetPending"
            class="success mx-1"
            :loading="loading"
            >Remove Pending Payment</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String
    },
    cartIsTracked: {
      type: Boolean
    }
  },
  data() {
    return {
      paymentFlag: false,
      loading: false,
      dialog: false
    };
  },
  methods: {
    getPaymentPending() {
      cartApi.getPaymentForCart(this.cartId).then(res => {
        if (res.isPaid) {
          this.paymentFlag = true;
        } else {
          this.paymentFlag = false;
        }
      });
    },
    submitResetPending() {
      this.loading = true;
      cartApi.postUpdatepaymentStatus(this.cartId, true).then(() => {
        this.loading = false;
        this.dialog = false;
        this.$emit("paymentSet");
      });
    },
    submitSetPending() {
      this.loading = true;
      cartApi.postUpdatepaymentStatus(this.cartId, false).then(() => {
        this.loading = false;
        this.dialog = false;
        this.$emit("paymentSet");
      });
    }
  }
};
</script>
